module.exports = __webpack_public_path__ + "img/custom_bg2.19aeb493.png";